// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ac8jnnp4cSuxgNv6v1Xr {
    position: relative;
    height: 40vh;
    background-color: white;
    width: 220px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    padding-bottom: 5px;
}
.ji_5SHiqaIN0179ag4_m {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: -5px;
    padding: 0 15px;
    flex-shrink: 0;
}
.OFiP0zs7mlCE0BfF15yO{
    color: #1976D2;
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;
}
.hyzGCrMl3KM0mNNDHSut {
    overflow-y: hidden;
    overflow-x: hidden;
    flex: 1;
}
.hyzGCrMl3KM0mNNDHSut::-webkit-scrollbar {
    display: none;
}
.BsZtN7PKG2SlaSbbf_HQ {
    text-align: center;
    margin-top: 25%;
}
.WQkklr1nu5yfUGBc69bb {
    cursor: pointer;
    padding: 2px 5px;
    display: flex;
}
.kO6qsYUusWQZmriYoe3S {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 170px;
    word-break: break-word;
}
.kO6qsYUusWQZmriYoe3S p {
    margin: 0;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.yeIcp28xjlUSIA0zqZfw {
    margin: 2px 5px 0 0;
}
.thpHdA568Q0n0cPYZLVk{
    width: 5px;
    height: 5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/*mobile view*/
@media screen and (max-width:600px){

    .WPSkGlmOQqJ_Uk4lMzKw{
        min-height: 100vh;
        padding: 20px;
        max-width: 600px;
        margin-top: -4rem;
        background-color: #f5f5f5;
    }
    .jDZpNvGOwLStdwbr9ZcJ{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 2px;
    }

    .cXcx0GkqCmjgysLs0C7g {
        margin: 7px 0;
    }
    .W7E0d9ob03N2u6gtOAdT{
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 20px;
    }

    .wS6qqQRTqmIqSI81MWgy {
        padding: 15px;
        border: 2px solid white;
        border-radius: 10px;
        background-color: #fff;
    ;
    }

    .o8UNGibB1kD9x_5sFHHE {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .yQY1JYQp5Ocg6ivv5kDs {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: #fff;
        font-weight: bold;
    }

    .C6lctnWbfaEusm_1NcPt{
        flex-grow: 1;
        margin-left: 10px;
    }

    .VkZNT09uNKuwU6_6_hIu {
        font-size: 15px;
        font-weight: 600;
        color: rgba(33, 33, 33, 1);
        font-family: 'Nunito Sans', Sans-serif, serif;
        display: block;
    }

    .gOspZMxXhM3Fhk6p_Ui1 {
        font-size: 14px;
        margin-top: 2px;
        font-weight: 400;
        font-family: 'Nunito Sans', Sans-serif, serif;
    }

    .fIkgAd0nZtO0DPqzHSwb {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
    }

    .TKzuaHT8eZGt5Dzp4d_G {
        color: black;
        background-color:rgba(245, 245, 245, 1);
        padding: 7px;
        border-radius: 16px;
        font-weight: 400;
    }

    .fPv10sLKbN4xlCUX92zl img {
        width: 20px;
        background-color:rgba(245, 245, 245, 1);
        padding: 7px;
        /*border: 0 solid #555555 ;*/
        border-radius: 16px;
        cursor: pointer;
    }

    .qQVAUCRJ1d19YRuYcKl4 {
        font-size: 18px;
        color: rgba(0, 75, 160, 1);
        font-weight: 700;
        font-family: Nunito Sans, Sans-serif, serif;
        cursor: pointer;
        margin: 0;
    }

    .bV8GVMpOLgjAkuNoptYE {
        color: black;
        font-size: 15px;
        margin-top: 5px;
        line-height: 1.5;
        font-weight: 400;
    }

}
`, "",{"version":3,"sources":["webpack://./src/home/css/communitySubsections.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,cAAc;AACd;;IAEI;QACI,iBAAiB;QACjB,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;;IAE1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,0BAA0B;QAC1B,6CAA6C;QAC7C,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,6CAA6C;IACjD;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,uCAAuC;QACvC,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,uCAAuC;QACvC,YAAY;QACZ,4BAA4B;QAC5B,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,0BAA0B;QAC1B,gBAAgB;QAChB,2CAA2C;QAC3C,eAAe;QACf,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;AAEJ","sourcesContent":[".subSectionsMain {\n    position: relative;\n    height: 40vh;\n    background-color: white;\n    width: 220px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 5px;\n}\n.subSectionsHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-left: -5px;\n    padding: 0 15px;\n    flex-shrink: 0;\n}\n.seeAll{\n    color: #1976D2;\n    font-weight: bold;\n    font-size: 13px;\n    cursor: pointer;\n}\n.scrollableContent {\n    overflow-y: hidden;\n    overflow-x: hidden;\n    flex: 1;\n}\n.scrollableContent::-webkit-scrollbar {\n    display: none;\n}\n.noQuestions {\n    text-align: center;\n    margin-top: 25%;\n}\n.questionItem {\n    cursor: pointer;\n    padding: 2px 5px;\n    display: flex;\n}\n.questionDescription {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 170px;\n    word-break: break-word;\n}\n.questionDescription p {\n    margin: 0;\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.subSectionIcon {\n    margin: 2px 5px 0 0;\n}\n.loader{\n    width: 5px;\n    height: 5px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n/*mobile view*/\n@media screen and (max-width:600px){\n\n    .trendingContainers{\n        min-height: 100vh;\n        padding: 20px;\n        max-width: 600px;\n        margin-top: -4rem;\n        background-color: #f5f5f5;\n    }\n    .headerContainers{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-top: 2px;\n    }\n\n    .searchContainers {\n        margin: 7px 0;\n    }\n    .questionsLists{\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        margin-top: 20px;\n    }\n\n    .questionCards {\n        padding: 15px;\n        border: 2px solid white;\n        border-radius: 10px;\n        background-color: #fff;\n    ;\n    }\n\n    .questionHeaders {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 10px;\n    }\n\n    .userAvatars {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 18px;\n        color: #fff;\n        font-weight: bold;\n    }\n\n    .userDetails{\n        flex-grow: 1;\n        margin-left: 10px;\n    }\n\n    .userNames {\n        font-size: 15px;\n        font-weight: 600;\n        color: rgba(33, 33, 33, 1);\n        font-family: 'Nunito Sans', Sans-serif, serif;\n        display: block;\n    }\n\n    .createdDates {\n        font-size: 14px;\n        margin-top: 2px;\n        font-weight: 400;\n        font-family: 'Nunito Sans', Sans-serif, serif;\n    }\n\n    .questionActions {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        font-size: 14px;\n    }\n\n    .answersCounts {\n        color: black;\n        background-color:rgba(245, 245, 245, 1);\n        padding: 7px;\n        border-radius: 16px;\n        font-weight: 400;\n    }\n\n    .shareIcons img {\n        width: 20px;\n        background-color:rgba(245, 245, 245, 1);\n        padding: 7px;\n        /*border: 0 solid #555555 ;*/\n        border-radius: 16px;\n        cursor: pointer;\n    }\n\n    .questionTitles {\n        font-size: 18px;\n        color: rgba(0, 75, 160, 1);\n        font-weight: 700;\n        font-family: Nunito Sans, Sans-serif, serif;\n        cursor: pointer;\n        margin: 0;\n    }\n\n    .questionDescriptions {\n        color: black;\n        font-size: 15px;\n        margin-top: 5px;\n        line-height: 1.5;\n        font-weight: 400;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subSectionsMain": `ac8jnnp4cSuxgNv6v1Xr`,
	"subSectionsHeader": `ji_5SHiqaIN0179ag4_m`,
	"seeAll": `OFiP0zs7mlCE0BfF15yO`,
	"scrollableContent": `hyzGCrMl3KM0mNNDHSut`,
	"noQuestions": `BsZtN7PKG2SlaSbbf_HQ`,
	"questionItem": `WQkklr1nu5yfUGBc69bb`,
	"questionDescription": `kO6qsYUusWQZmriYoe3S`,
	"subSectionIcon": `yeIcp28xjlUSIA0zqZfw`,
	"loader": `thpHdA568Q0n0cPYZLVk`,
	"trendingContainers": `WPSkGlmOQqJ_Uk4lMzKw`,
	"headerContainers": `jDZpNvGOwLStdwbr9ZcJ`,
	"searchContainers": `cXcx0GkqCmjgysLs0C7g`,
	"questionsLists": `W7E0d9ob03N2u6gtOAdT`,
	"questionCards": `wS6qqQRTqmIqSI81MWgy`,
	"questionHeaders": `o8UNGibB1kD9x_5sFHHE`,
	"userAvatars": `yQY1JYQp5Ocg6ivv5kDs`,
	"userDetails": `C6lctnWbfaEusm_1NcPt`,
	"userNames": `VkZNT09uNKuwU6_6_hIu`,
	"createdDates": `gOspZMxXhM3Fhk6p_Ui1`,
	"questionActions": `fIkgAd0nZtO0DPqzHSwb`,
	"answersCounts": `TKzuaHT8eZGt5Dzp4d_G`,
	"shareIcons": `fPv10sLKbN4xlCUX92zl`,
	"questionTitles": `qQVAUCRJ1d19YRuYcKl4`,
	"questionDescriptions": `bV8GVMpOLgjAkuNoptYE`
};
export default ___CSS_LOADER_EXPORT___;
